angular.module('v3sWbtPlayerApp').factory('v3sLog', ["$rootScope", "$alert", "v3sI18nService", "$log", "v3sLoaderService", "v3sContentPath", function ($rootScope, $alert, v3sI18nService, $log, v3sLoaderService, v3sContentPath) {

    var debugOn = null;
    var alerts = {};
    var debugInfo = "";

    v3sLoaderService('wbtInfo.js', v3sContentPath).then(function (wbtInfo) {
        debugInfo += wbtInfo.app + " " + wbtInfo.appVersion + "\n";
        debugInfo += "Course: " + wbtInfo.wbtTitle + ", Version: " + wbtInfo.wbtVersion + "\n";
        debugInfo += "Published: " + wbtInfo.datePublished + "\n";
    });

    function log(msg) {
        $log.log(msg);
    }

    function info(msg, withAlert, msgData) {
        if (msg) $log.info(msg);
        if (msgData) $log.info(msgData);

        debug(msg, msgData);

        if (!!withAlert) {
            showAlert(msg, 'general.info', 'info', msgData);
        }
    }

    function warn(msg, withAlert, msgData) {
        if (msg) $log.warn(msg);
        if (msgData) $log.warn(msgData);

        debug(msg, msgData);

        if (!!withAlert) {
            showAlert(msg, 'general.warn', 'warn', msgData);
        }
    }

    function debug(msg, msgData) {
        if (!!msgData) {
            msg += ": " + angular.toJson(msgData);
        }
        debugInfo += new Date().toLocaleString() + ": " + msg + "\n";
    }

    //Debug ist per Default aktiviert (debugOn = null) erstes setDebugOn-Aufruf überschreibt Debug-Modus
    function isDebugOn() {
        return debugOn == null || !!debugOn;
    }

    function setDebugOn(on) {
        if (typeof on !== "undefined" || debugOn === null) {
            debugOn = !!on;
        }
    }

    function error(msg, error, msgData) {
        if (msg) $log.error(msg);
        if (msgData) $log.error(msgData);

        debug(msg, msgData);

        if (!!error) {
            debug(error);
        }

        showAlert(msg, 'general.error', 'error', msgData);
    }

    function success(msg, withAlert, msgData) {
        debug(msg, msgData);

        if (!!withAlert) {
            showAlert(msg, 'general.success', 'success', msgData);
        }
    }

    function progress(msg, withAlert, msgData) {
        debug(msg, msgData);

        if (!!withAlert) {
            showAlert(msg, 'general.warn', 'progress', msgData);
        }
    }

    function showAlert(msg, title, type, msgData) {
        if (!alerts[msg]) {

            var alert = function () {

                $rootScope.$on('v3sLog.hide.before', function (event) {
                    alerts[msg] = null;
                });

                var scope = $rootScope.$new();
                scope.msgData = msgData;

                var alert = $alert({
                    templateUrl: 'app/js/helper/log/log.tpl.html',
                    title: v3sI18nService.getText(title),
                    content: v3sI18nService.getText(msg, msgData),
                    placement: 'v3s-log top-right',
                    animation: '',
                    type: type,
                    show: true,
                    prefixEvent: "v3sLog",
                    scope: scope
                });

                alert.$promise.then(function () {
                    alert.show();
                    alerts[msg]= alert;
                });
            };

            var loaded = v3sI18nService.loadLibrary();
            if (loaded === true) {
                alert();
            } else {
                loaded.then(function () {
                    alert();
                });
            }
        }
    }

    function close(msg) {
        if (!!alerts[msg]) {
            alerts[msg].hide();
            alerts[msg] = null;
        }
    }

    return {
        log: log,
        info: info,
        warn: warn,
        debug: debug,
        getDebugInfo : function(){return debugInfo},
        setDebugOn: setDebugOn,
        isDebugOn: isDebugOn,
        error: error,
        success: success,
        progress: progress,
        close: close
    }
}]);